module.exports = __webpack_public_path__ + "img/background.0b3ec159.jpg";